import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailPersonal } from '../dto/trail-personal';

@Injectable({
  providedIn: 'root'
})
export class TrailPersonalService {

  private apiUrl = environment.apiRoot + '/trialpersonal';

  constructor(private http: HttpClient) { }

  getAllPersonalOfTrial(trialId: number): Observable<TrailPersonal[]> {
    return this.http.get<TrailPersonal[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  createPersonal(trialId: number): Observable<TrailPersonal> {
    let model = { "id": 0, "trial_id": trialId, "name": "new personal" };
    return this.http.post<TrailPersonal>(this.apiUrl + '/new', model);
  }

  updatePersonal(model: TrailPersonal): Observable<TrailPersonal> {
    return this.http.put<TrailPersonal>(this.apiUrl + '/update', model);
  }

  deletePersonal(trialPersonalId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialPersonalId=' + trialPersonalId);
  }

}
